<template>
  <div>
    <v-btn :outline="selectedCount === 0" color="primary" @click="showModal" :disabled="disabled">{{buttonText}}</v-btn>

    <v-dialog v-model="modal" :max-width="350">
      <v-card>
          <v-container>
            <h2 class="text-xs-center">{{buttonTitle}}</h2>
            <v-layout row justify-start>
              <v-icon class="mr-1">mdi-blank</v-icon>
              <v-text-field class="mr-4 pt-1" clearable append-icon="search" v-model="searchText" :placeholder="$t('student.filters.list_search_placeholder')"></v-text-field>
            </v-layout>
            <div v-if="modal" class="filter-list-rows">
              <transition-group name="filter-list">
                <div v-for="row in filteredRows" :key="source.key(row)" :class="tableRowClass">
                  <filter-list-row :row="source.mapRow(row)" :idSet="idSet" @selected="selected"></filter-list-row>
                </div>
              </transition-group>
            </div>
          </v-container>

          <v-card-actions>
            <v-layout row justify-center class="pt-1 pb-1">
              <v-btn @click="clear" :disabled="selectedCount === 0">{{$t('student.filters.clear')}}</v-btn>
              <v-btn @click="closeModal" color="primary">{{$t('student.filters.okay')}}</v-btn>
            </v-layout>
          </v-card-actions>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FilterListRow from './FilterListRow'
import Helpers from '../../mixins/Helpers'

export default {
  name: 'filter-list',
  mixins: [Helpers],
  data () {
    return {
      modal: false,
      searchText: ''
    }
  },
  methods: {
    showModal () {
      this.modal = true
    },
    closeModal () {
      this.modal = false
    },
    clear () {
      this.$emit('filter:list-change', {filterName: [], filterType: this.filterType})
    },
    selected (selection) {
      let ids = new Set(this.idSet)
      if (selection.selected) {
        ids.add(selection.id)
      } else {
        ids.delete(selection.id)
      }
      this.$emit('filter:list-change', {filterName: Array.from(ids.keys()), filterType: this.filterType})
    }
  },
  props: {
    source: {
      type: Object,
      required: true
    },
    filterType: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean
    }
  },
  computed: {
    idSet () {
      let ids = new Set()
      Object.keys(this.source.idValues).forEach(id => {
        if (this.source.identifier === 'course' || this.source.identifier === 'courseYears') {
          ids.add(parseInt(id))
        } else {
          ids.add(id)
        }
      })
      return ids
    },
    selectedCount () {
      return Object.keys(this.source.idValues).length
    },
    buttonTitle () {
      return this.$t(this.source.title_i18n) + ' ' + this.$t('selection_label')
    },
    buttonText () {
      if (this.selectedCount === 0) {
        return this.$t('all_label') + ' ' + this.$t(this.source.button_unselected_i18n)
      } else {
        // original
        let x = this.$t(this.source.button_i18n, {count: this.selectedCount}, this.selectedCount)
        // remove count to look up in translations
        let y = this.$t(x.substring(x.indexOf(this.selectedCount) + this.selectedCount.toString().length + 1, x.length))
        // re-apply count to translated text
        return this.selectedCount + ' ' + y
      }
    },
    filteredRows () {
      let text = (this.searchText === null) ? '' : this.searchText.trim()
      return this.source.items.filter(item => this.source.containsText(item, text))
    }
  },
  components: {
    FilterListRow
  }
}
</script>

<style scoped>
.filter-list-rows {
  overflow: auto;
  height: 55vh;
  max-height: calc(100vh - 340px);
  -webkit-overflow-scrolling: touch;
}
  /* Transitions */
.filter-list-enter-active,
.filter-list-leave-active {
  transition: all 0.4s;
  opaque: 1;
}

.filter-list-enter, .filter-list-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
  transform: translate(-16px, 0px)
}
</style>



// WEBPACK FOOTER //
// src/components/filter/FilterList.vue